import React, { useState } from "react";
import { AppBar, Toolbar, IconButton, Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import SportsHandballIcon from "@mui/icons-material/SportsHandball";
import QuizIcon from "@mui/icons-material/Quiz";
import HelpIcon from "@mui/icons-material/Help";
import { Link } from "react-router-dom";
import webImage from "../assets/web.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (state) => () => setOpen(state);

  const menuItems = [
    { text: "Home", icon: <HomeIcon />, path: "/" },
    { text: "Questionnaire", icon: <QuizIcon />, path: "/questionnaire" },
    { text: "Conditioning", icon: <SportsHandballIcon />, path: "/conditioning" },
    { text: "About App", icon: <InfoIcon />, path: "/about" },
    { text: "How to Use?", icon: <HelpIcon />, path: "/how-to-use" },
  ];

  return (
    <>
      <AppBar position="sticky" sx={{ background: "#ADD8E6", padding: "5px 5pxpx" }}>
        <Toolbar sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {/* Logo Image (Scales with Navbar) */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
              src={webImage}
              alt="Ear"
              style={{ height: "30px", maxWidth: "100px", objectFit: "contain" }}
            />
          </Box>

          {/* Title */}
          <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center", fontWeight: "bold", color: "#000" }}>
            Sajjata Shravana
          </Typography>

          {/* Menu Button */}
          <IconButton edge="end" color="inherit" onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Drawer (Sidebar) */}
      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <List>
          {menuItems.map((item, index) => (
            <ListItem button key={index} component={Link} to={item.path} onClick={toggleDrawer(false)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;
